module.exports = __webpack_public_path__ + "static/media/servicios_medioambiente.0c84a36b.jpg";